import moment from "moment"

export const formatDateTime = (date?: string) => {
    try {
        return date ? moment(date).format("MM/DD/YYYY h:mm A") : "";
    } catch(error) {
        console.log("error", error)
        return "";
    }
};
